
import commonStore from './commonStore';
import businessProfileStore from './businessProfileStore';
import loanStore from './loanStore';
import viewStore from './viewStore';
import verifyIdStore from './verifyIdStore';
import emailStore from './emailStore';
import onboardingStore from './onboardingStore';

const stores = {
    commonStore,
    businessProfileStore,
    loanStore,
    viewStore,
    verifyIdStore,
    emailStore,
    onboardingStore
};

export default stores;
